import { createYouTubeHandler } from '../../../MediaController';
import { hasYouTubeIframeAPILoaded, loadYouTubeIframeAPI } from '../../../Utility/YouTube';
import { MediaControllerController } from './MediaControllerController';

export class YoutubeController extends MediaControllerController {
    type = 'YOUTUBE';

    constructor(wrapperElement: HTMLDivElement, url: string) {
        const handler = createYouTubeHandler({
            continuousPlayback: true,
            muted: false,
            youtubeLink: url,
        });
        super(wrapperElement, handler);
    }

    canBePlayed(): Promise<boolean> {
        return Promise.resolve(hasYouTubeIframeAPILoaded());
    }

    async getReadyForDisplay(): Promise<void> {
        await loadYouTubeIframeAPI();
        await super.getReadyForDisplay();
    }
}
